import { render, staticRenderFns } from "./ProSection.vue?vue&type=template&id=6f8f16e8&scoped=true&"
import script from "./ProSection.vue?vue&type=script&lang=js&"
export * from "./ProSection.vue?vue&type=script&lang=js&"
import style0 from "./ProSection.vue?vue&type=style&index=0&id=6f8f16e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8f16e8",
  null
  
)

export default component.exports